'use strict';
angular
    .module('iWoMyManuscriptModule', [
        'iWoManuscriptArchivesRouterModule',
        'iWoPersonalManuscriptModule',
        'iWoPersonalManuscriptRouterModule',
        'iWoReceivedManuscriptRouterModule',
        'iwoDepartmentManuscriptRouterModule',
        'iwoIssueManuscriptRouterModule',
        'myShareRouterModule',
        'iWoReceivedManuscriptModule',
        'iWoManuscriptArchivesModule',
        'iWoAtlas',
        'iWoPersonalNewsModule',
        'iWoLinkDocModule',
        'iWoVideoModule',
        'editingCenterServiceModule',
        'initiWoDataModule',
        'iWoinitBtnModule',
        'newspaperAwaitReviseModule',
        'iWoBroadcastTvManuscriptModule',
        'iWoPlannedOrderModule',
        'iwoPlannedOrderEditModule',
    ])
    .controller('iWoMyManuscript', ['$scope', function($scope) {}]);
